module.exports = __webpack_public_path__ + "img/logo.dark.d6140de2.svg";